import React from 'react';
import HeaderLogo from 'components/common/headerLogo';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import BorderLinearProgress from 'components/common/borderLinearProgress';
import clsx from 'clsx';

type Props = {
  currentPage: number;
  totalPage: number;
  onClickBackButton: (pageNumber: number) => void;
  hasBackButton?: boolean;
 }

export function Header({
  currentPage,
  totalPage,
  onClickBackButton,
  hasBackButton = true,
}: Props) {
  const handleBackButton = (pageNumber: number) => {
    onClickBackButton(pageNumber);
  };

  const classes = clsx('flex h-6');

  return (
    <div className="fixed bg-white z-10 w-[inherit] max-w-[496px] px-3">
      <HeaderLogo />
      {currentPage <= totalPage ? (
        <div className="mt-1 overflow-hidden">
          <p className={classes}>
            {currentPage !== 1 && hasBackButton && (
              <Button
                onClick={() => {
                  handleBackButton(currentPage - 1);
                }}
                className="!text-populate-green px-0"
                disabled={currentPage === 1}
                startIcon={(
                  <ChevronLeftIcon
                    className="text-populate-green"
                    fontSize="large"
                  />
                  )}
              >
                Back
              </Button>
            )}
          </p>
          <BorderLinearProgress
            totalPage={totalPage}
            currentPage={currentPage}
          />
        </div>
      ) : null}
    </div>
  );
}

export default Header;
